import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

// Conditional route configuration based on sessionStorage
export const routes: Routes = [
  {
    path: 'bulkentry',
    loadChildren: () =>
      import('./pages/sparci.routes').then(m => m.sparci_routes),
    canActivate: [MsalGuard],
  },
  {
    path: 'customreports',
    loadChildren: () =>
      import('./features/custom-report/custom-report.routes').then(m => m.CUSTOM_REPORT_ROUTES),
    canActivate: [MsalGuard],
  }
];
